import { ref } from 'vue';
import DBData from '@/dbdata';

class State_LiveControlData {
    constructor() {
        this.db = new DBData();
        this.serviceMode = ref(null);   // 'live' | 'standby' | null
        this.vehicles = ref([]);        // [{ id, mode }]
        this.connected = ref(false);
        this.lastError = ref(null);

        this._pollHandle = null;
    }

    async refresh() {
        try {
            const state = await this.db.getLiveControlState();
            this.serviceMode.value = state.serviceMode ?? null;
            this.vehicles.value = state.vehicles ?? [];
            this.connected.value = !!state.connected;
            this.lastError.value = null;
        } catch (err) {
            console.error('LiveControl refresh failed:', err);
            this.lastError.value = err.message || String(err);
        }
    }

    startPolling(intervalMs = 3000) {
        this.stopPolling();
        this.refresh();
        this._pollHandle = setInterval(() => this.refresh(), intervalMs);
    }

    stopPolling() {
        if (this._pollHandle) {
            clearInterval(this._pollHandle);
            this._pollHandle = null;
        }
    }

    async setServiceMode(mode) {
        const previous = this.serviceMode.value;
        this.serviceMode.value = mode; // optimistic
        try {
            await this.db.setIpswServiceMode(mode);
        } catch (err) {
            console.error('setServiceMode failed:', err);
            this.serviceMode.value = previous;
            this.lastError.value = err.message || String(err);
        }
    }

    async setVehicleMode(vehicleId, mode) {
        const idx = this.vehicles.value.findIndex(v => v.id === vehicleId);
        const previous = idx >= 0 ? this.vehicles.value[idx].mode : null;
        if (idx >= 0) {
            this.vehicles.value[idx] = { ...this.vehicles.value[idx], mode };
        }
        try {
            await this.db.setIpswVehicleMode(vehicleId, mode);
        } catch (err) {
            console.error(`setVehicleMode(${vehicleId}) failed:`, err);
            if (idx >= 0) {
                this.vehicles.value[idx] = { ...this.vehicles.value[idx], mode: previous };
            }
            this.lastError.value = err.message || String(err);
        }
    }

    async clearVehicleMode(vehicleId) {
        const idx = this.vehicles.value.findIndex(v => v.id === vehicleId);
        const previous = idx >= 0 ? this.vehicles.value[idx].mode : null;
        if (idx >= 0) {
            this.vehicles.value[idx] = { ...this.vehicles.value[idx], mode: null };
        }
        try {
            await this.db.clearIpswVehicleMode(vehicleId);
        } catch (err) {
            console.error(`clearVehicleMode(${vehicleId}) failed:`, err);
            if (idx >= 0) {
                this.vehicles.value[idx] = { ...this.vehicles.value[idx], mode: previous };
            }
            this.lastError.value = err.message || String(err);
        }
    }
}

export default State_LiveControlData;
